import styled from 'styled-components';
import CsvDownloader from 'react-csv-downloader';

export const CsvWrapper = styled(CsvDownloader)``;
